import React from "react";
import { RiArrowGoBackFill } from "react-icons/ri";
import { AiGlossaryCreateForm } from "@components";
import { Card, Row, Col } from "antd";

const AiGlossaryCreate = ({ history }) => {
  return (
    <>
      <Card style={{ borderRadius: "0", height: "100vh", overflowY: "auto" }}>
        <Row>
          <Col span={24}>
            <Row>
              <RiArrowGoBackFill
                style={{ fontSize: "2em", cursor: "pointer" }}
                onClick={() => history.goBack()}
              />
              <h3
                className="hp-mb-16"
                style={{
                  marginLeft: "1em",
                  fontSize: "1.75em",
                }}
              >
                Create a AI Glossary
              </h3>
            </Row>
            {/* Space */}
            <Row style={{ marginTop: "1em" }} />
            {/* AiGlossary Create Form */}
            <AiGlossaryCreateForm />
          </Col>
        </Row>
      </Card>
    </>
  );
};

export default AiGlossaryCreate;
